import {Component, OnInit} from '@angular/core';
import {Driver, SourceBI, SourceDWH} from '../../data-access-layer/interfaces/source.interface';
import {SourceService} from '../../data-access-layer/services/sources.service';
import { AuthService } from '../../data-access-layer/services/auth.service';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { StatusDialogComponent, DialogData } from './status_dialog.component';
import { LoadingService } from '../../data-access-layer/services/loading.service';
import { AlertService } from '../../data-access-layer/services/alert.service';
import { SourceDialogComponent } from './source-settings.component';


@Component({
  selector: 'app-root',
  templateUrl: '../templates/sources.component.html',
  styleUrls: ['../templates/styles/sources.component.css'],
  standalone: false
})
export class SourcesComponent implements OnInit {

  public sourcesDWH: SourceDWH[] = [];
  public sourcesBI: SourceBI[] = [];
  public sources: any;
  public amountSources = 0;
  public selectedSource: any = {}
  public isCreate: boolean = false;
  public isDeleteMode: boolean = false;
  public showDeleteButtons: boolean = false;
  public isAdmin = false;

  public showSettings = false;

  public open: boolean = false;

  isShowBI: boolean = false;
  public isEditing = false;

  public isDataCatalog: boolean = false;
  public isAgent: boolean = false;
  public isNewSource = false;

  public driversDWH: Driver[] = [
    {driverName: "MS SQL", defaultPort: "1433"},
    {driverName: "PostgreSQL", defaultPort: "5432"},
    {driverName: "ClickHouse", defaultPort: "8123"},
    {driverName: "Greenplum", defaultPort: "5432" },
  ];

  public typesBI: Driver[] = [
    { driverName: "Analytic Workspace", defaultPort: "" },
    { driverName: "Superset", defaultPort: "8088" },
    { driverName: "Power BI", defaultPort: "14033" },
    { driverName: "PixBI", defaultPort: "5432" },
    { driverName: "AlphaBI", defaultPort: "5432" },
  ];

  public isLoading: boolean = false;

  private originalSourceBackup: any = null;

  constructor(private sourceService: SourceService, private authService: AuthService, private dialog: MatDialog, private loadingService: LoadingService, private alertService: AlertService) {
    this.loadingService.loading$.subscribe((loading: boolean) => {
      this.isLoading = loading;
    });
  }

  ngOnInit(): void {
    this.getSources();
    this.isAdmin = this.authService.isAdmin();
  }

  getSources(): void {
    const currentSourceId = this.selectedSource?.id;
    
    if (!this.isShowBI)
      this.sourceService.getDWHSources().subscribe((response) => {
        this.sources = response;
        this.amountSources = this.sources.length;
        // Сохраняем текущий выбранный источник или выбираем первый
        const sourceToSelect = currentSourceId 
          ? this.sources.find((s: any) => s.id === currentSourceId) || this.sources[0]
          : this.sources[0];
        if (sourceToSelect) {
          this.selectSource(sourceToSelect);
        }
      });

    else {
      this.sourceService.getBISources().subscribe((response) => {
        this.sources = response;
        this.amountSources = this.sources.length;
        this.sources.forEach((source: any)=> {
          if (!source.dbSettings) return; // пропустить пустые
          try {
            const cfg = JSON.parse(source.dbSettings) as {
              port?: string;
              base_url?: string;
              password?: string;
              username?: string;
              server?: string;
              database?: string;
            };

            source.dbPort = cfg.port ?? '';
            source.dbUser = cfg.username ?? '';
            source.dbPassword = cfg.password ?? '';
            source.dbServer = cfg.base_url ?? cfg.server ?? '';
            source.dbDatabase = cfg.database ?? '';
          } catch (e) {
            console.warn('Ошибка парсинга dbSettings у источника', source, e);
          }
        });

        // Сохраняем текущий выбранный источник или выбираем первый
        const sourceToSelect = currentSourceId 
          ? this.sources.find((s: any) => s.id === currentSourceId) || this.sources[0]
          : this.sources[0];
        if (sourceToSelect) {
          this.selectSource(sourceToSelect);
        }
      });
    }
   
  }

  selectSource(source: any): void {
    this.selectedSource = source;
    this.isCreate = false;

    if (this.isShowBI) {
      const cfg = JSON.parse(source.dbSettings) as {
        port: string;
        base_url: string;
        password: string;
        username: string;
        server: string;
        database: string;
        site_usr: string;
        site_pwd: string;
        uid: string;
        db_server: string;
        db_port: string;
        db_username: string;
        db_password: string;
        site_url: string;
        site_port: string;
      };
      this.selectedSource.dbPort = cfg.port ?? cfg.db_port;
      this.selectedSource.dbUser = cfg.username ?? cfg.uid ?? cfg.db_username;
      this.selectedSource.dbPassword = cfg.password ?? cfg.site_pwd ?? cfg.db_password;
      if (this.selectedSource.dbType == "Power BI") {
        this.selectedSource.dbServer = cfg.server;
        this.selectedSource.baseUrl = cfg.base_url;
        this.selectedSource.siteUser = cfg.site_usr;
        this.selectedSource.sitePassword = cfg.site_pwd;
      }
      else if (this.selectedSource.dbType == "DeltaBI") {
        this.selectedSource.dbUser = cfg.db_username;
        this.selectedSource.dbPassword = cfg.db_password;
        this.selectedSource.dbServer = cfg.db_server;
        this.selectedSource.siteUrl = cfg.site_url;
        this.selectedSource.sitePort = cfg.site_port;
        this.selectedSource.siteUser = cfg.username;
        this.selectedSource.sitePassword = cfg.password;
      }
      else {
        this.selectedSource.dbServer = cfg.base_url ?? cfg.server;
      }
      this.selectedSource.dbDatabase = cfg.database;
    }

    try {
      const jsonData = JSON.parse(JSON.parse(this.selectedSource.dataCatalogTypeSettings || '{}'));

      // Извлечение данных из JSON
      if (jsonData.providers) {
        const openMetadata = jsonData.providers.OpenMetadata;
        this.selectedSource.dataCatalogIsConnected = openMetadata?.isConnected ?? false;
        this.selectedSource.dataCatalogHost = openMetadata?.host ?? "";
        this.selectedSource.dataCatalogPort = openMetadata?.port ?? "";
        this.selectedSource.dataCatalogService = openMetadata?.service ?? ""; 
        this.selectedSource.openMetadataPassword = openMetadata?.password ?? ""; 
        this.selectedSource.openMetadataUsername = openMetadata?.user ?? "";
      }
    } catch (e) {
      console.warn('Invalid JSON in source.dbSettings:', e);
    }


  }

  createSource(): SourceDWH {
    return {
      id: 0,
      dataSourceName: "",
      dbDriver: this.driversDWH[0].driverName,
      dbServer: "",
      dbPort: "",
      dbDatabase: "",
      dbUser: "",
      dbPassword: "",

      isConnectedDataCatalog: true,
      dataCatalogHost: "",
      dataCatalogPort: "",
      dataCatalogUserName: "",
      dataCatalogPassword: "",
      dataCatalogService: ""
    };
  }

  createSourceBI(): SourceBI {
    return {
      id: 0,
      dataSourceName: "",
      dbSettings: JSON.stringify({ "port": "", "base_url": "", "username": "", "password": "" }),
      dbType: this.typesBI[0].driverName,
    };
  }

  addSource(): void {
    if (!this.isShowBI)
      this.selectedSource = this.createSource();
    else
      this.selectedSource = this.createSourceBI();
    this.showSettings = true;
    this.isDataCatalog = false;
    this.isNewSource = true;
  }

  editSource() {
    this.showSettings = true;
    this.isDataCatalog = false;
    this.isNewSource = false;
    this.isAgent = false;
  }

  dataCatalogSource() {
    this.showSettings = true;
    this.isDataCatalog = true;
    this.isNewSource = false;
    this.isAgent = false;
  }

  openAgent() {
    setTimeout(() => {
      this.showSettings = true;
      this.isDataCatalog = false;
      this.isNewSource = false;
      this.isAgent = true;
    }, 0);
  }

  deleteSource(): void {
    this.isEditing = false;
    if (!this.selectedSource)
      return;

    this.alertService.confirm({
      title: 'Удаление источника',
      message: `Вы уверены, что хотите удалить источник "${this.selectedSource?.dataSourceName}"?`,
      confirmButtonText: 'Да',
      cancelButtonText: 'Отмена',
    }).subscribe((confirmed) => {
      if (confirmed) {
        const deleteRequest = {
          dataSourceId: this.selectedSource.id
        };

        if (!this.isShowBI) {
          this.sourceService.deleteDWH(deleteRequest).subscribe(() => {
            this.getSources();
          });
        } else {
          this.sourceService.deleteBI(deleteRequest).subscribe(() => {
            this.getSources();
          });
        }

        this.selectedSource = null;
      }
    });
  }

  toggleIsBI(isBI: boolean) {
    this.isShowBI = isBI;
    this.getSources();
  }

  toggleDataCatalog(isDataCatalog: boolean) {
    this.isDataCatalog = isDataCatalog;
  }

  toggleOpen() {
    this.open = !this.open;
  }

  enableEdit() {
    this.isEditing = true;
  }
}
